<template>
  <div class="tasks">
    <ul class="tasks__list">
      <div class="tasks__list-title">
        <r-title type="subtitle-2">
          {{ $t("tasks:title-active-tasks") }}
        </r-title>
      </div>
      <li
        class="tasks__item"
        v-for="task in activeUserTasks"
        :key="task.task_id"
      >
        <el-tooltip
          :open-delay="500"
          effect="dark"
          :content="getTaskHint(task.worker_class)"
          placement="top"
        >
          <div :class="getTaskImage(task.worker_class)" />
        </el-tooltip>
        <div class="tasks__block">
          <div class="tasks__block-row">
            <r-text type="caption">
              {{ $t("task:type") }}
            </r-text>
            <r-text>
              {{ $t(task.worker_class) }}
            </r-text>
          </div>
          <div class="tasks__block-row">
            <r-text type="caption">
              {{ $t("task:start_time") }}
            </r-text>
            <r-text>{{ getDate(task.start_time) }}</r-text>
          </div>
        </div>
        <div class="tasks__loader">
          <i class="el-icon-loading" />
        </div>
      </li>
      <div
        class="tasks__no-data"
        v-if="!tasks.length && !activeUserTasks.length"
      >
        {{ $t("tasks.no-active-tasks") }}
      </div>
    </ul>
    <div class="tasks__list-separator" />
    <ul class="tasks__list" v-if="finishedUserTasks.length">
      <div class="tasks__list-title">
        <r-title type="subtitle-2">
          {{ $t("tasks:title-finished-tasks") }}
        </r-title>
      </div>
      <li
        class="tasks__item"
        v-for="task in finishedUserTasks"
        :key="task.task_id"
      >
        <el-tooltip
          :open-delay="500"
          effect="dark"
          :content="getTaskHint(task.worker_class)"
          placement="top"
        >
          <div :class="getTaskImage(task.worker_class)" />
        </el-tooltip>
        <div class="tasks__block">
          <div class="tasks__block-row">
            <r-text type="caption">
              {{ $t("task:type") }}
            </r-text>
            <r-text>
              {{ $t(task.worker_class) }}
            </r-text>
          </div>
          <div class="tasks__block-row">
            <r-text type="caption">
              {{ $t("task:start_time") }}
            </r-text>
            <r-text>{{ getDate(task.start_time) }}</r-text>
          </div>
        </div>
        <div class="tasks__complete-status success" v-if="task.success">
          <i class="el-icon-success" />
        </div>
        <div class="tasks__complete-status error" v-else>
          <i class="el-icon-error" />
        </div>
      </li>
    </ul>
    <div class="tasks__controls">
      <el-button class="r-button simple" @click="openTasksModal">
        {{ $t("tasks:open-modal") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getTaskImage, getTaskHint } from "./configs";
import moment from "moment";

export default {
  watch: {
    tasks() {
      this.updateUserTasks();
    }
  },
  computed: {
    tasks() {
      return this.$store.state.activeTasks || [];
    },
    allUserTasks() {
      return this.$store.state.userTasks.list || [];
    },
    activeUserTasks() {
      return this.allUserTasks
        .filter(e => !e.done)
        .sort((a, b) => {
          if (
            moment(a.start_time).format("x") > moment(b.start_time).format("x")
          )
            return -1;
          if (
            moment(a.start_time).format("x") < moment(b.start_time).format("x")
          )
            return 1;
          return 0;
        });
    },
    finishedUserTasks() {
      return this.allUserTasks
        .filter(e => e.done)
        .sort((a, b) => {
          if (
            moment(a.start_time).format("x") > moment(b.start_time).format("x")
          )
            return -1;
          if (
            moment(a.start_time).format("x") < moment(b.start_time).format("x")
          )
            return 1;
          return 0;
        })
        .slice(0, 5);
    }
  },
  methods: {
    async updateUserTasks() {
      const { data } = await this.$store.dispatch("REQUEST", { url: `user` });

      this.$store.commit("SET_USER_TASKS_LIST", data.tasks);
    },
    openTasksModal() {
      this.$store.commit("OPEN_MODAL_WINDOW", "user-tasks");
    },
    getDate(date) {
      return moment(date).format("HH:mm DD.MM.YYYY");
    },
    getTaskImage,
    getTaskHint
  }
};
</script>

<style lang="scss">
.tasks {
  min-height: 100px;
  font-size: 12px;
  color: var(--text_secondary) !important;

  &__block {
    width: calc(100% - 80px);
    &-row {
      display: flex;
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 160px;
        &:first-child {
          width: 80px;
        }
      }
    }
  }

  &__header {
    font-weight: bold;
    margin-bottom: 5px;
  }
  &__item {
    display: flex;
    align-items: center;
    padding: 5px 0 8px 0;
    &:not(:last-child) {
      border-bottom: 1px solid;
      border-bottom-color: var(--dividers_low_contrast) !important;
    }
  }
  &__image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 10px;
    background-position: 50%;
    background-size: 50%;
    background-repeat: no-repeat;
    &.calc {
      background-color: #6435c9;
      background-image: url("../../assets/images/icons/calculator.svg");
    }
    &.import {
      background-color: #1fba45;
      background-image: url("../../assets/images/icons/share-arrow.svg");
      background-position-y: 45%;
    }
    &.other {
      background-color: #00b5ad;
      background-image: url("../../assets/images/icons/other_cube.svg");
    }
  }
  &__title {
    margin-bottom: 5px;
    font-weight: bold;
  }
  &__desc {
    font-style: italic;
  }
  &__loader {
    flex-shrink: 0;
    margin-left: auto;
    padding-left: 10px;
    i {
      font-size: 14px;
    }
  }
  &__no-data {
    padding: 12px 0;
    color: var(--text_secondary) !important;
  }
  &__complete-status {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 60px;
    i {
      font-size: 20px;
    }
    &.success {
      i {
        color: var(--accent_success);
      }
    }
    &.error {
      i {
        color: var(--accent_error);
      }
    }
  }
  &__controls {
    padding: 8px 0;
    display: flex;
    justify-content: center;
    .r-button {
      span {
        color: var(--accent_primary);
      }
      &:hover {
        opacity: 0.6;
      }
      &:active {
        opacity: 1;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "tasks:title-active-tasks": "Активные задачи",
    "tasks:title-finished-tasks": "Завершенные задачи",
    "tasks.no-active-tasks": "Активные задачи отсутствуют",
    "tasks.active-tasks::id": "ID задачи: ",
    "task:start_time": "Начало: ",
    "task:type": "Тип задачи: ",

    "tasks:open-modal": "открыть все задачи",
    
    "GeojsonImporter": "Импорт GEOJSON",
    "DataBaseImporter": "Подключение PostgreSQL таблицы",
    "SkimMatrix": "SkimMatrix",
    "TileLayerImporter": "Импорт TileLayer",
    "DemandMatrix": "DemandMatrix",
    "StatisticsDataWriter": "StatisticsDataWriter",
    "CalculationRuner": "CalculationRuner",
    "ChsmeoCamsDataWriter": "ChsmeoCamsDataWriter",
    "LTMProcess": "Расчет LTM",
    "DataImport": "Импорт данных",
    "TestWorker": "TestWorker",
    "DueProcess": "Расчет DUE",
    "OsrmProcess": "Подготовка данных для OSRM",
    "VisumProcess": "Тестовый расчет Visum",
    "STA": "STA",
    "GdbImporter": "Импорт GDB",
    "NetImporter": "Импорт NET",
    "DueImporter": "Импорт DUE",
    "CustomImporter": "Создание пользовательского слоя",
    "CsvImporter": "Импорт CSV",
    "DmdImporter": "Импорт DMD",
    "UserImporter": "Импорт пользовательских данных",
    "JsonImporter": "Импорт JSON",
    "GtfsImporter": "Импорт GTFS",
    "ShpImporter": "Импорт SHP",
    "OsmExport": "Экспорт в OSM",
    "LtmExport": "Экспорт данных для LTM",
    "DueExport": "Экспорт данных для DUE",
    "DorfondImporter": "Импорт данных Dorfond",
    "TracksImporter": "Импорт данных трэков",
    "DnlProcess": "Расчет DNL"
  },
  "en": {
    "tasks:title-active-tasks": "Active tasks",
    "tasks:title-finished-tasks": "Finished tasks",
    "tasks.no-active-tasks": "No active tasks",
    "tasks.active-tasks::id": "Task ID: ",
    "task:start_time": "Start: ",
    "task:type": "Task type: ",

    "tasks:open-modal": "all tasks",
    
    "GeojsonImporter": "GEOJSON import",
    "DataBaseImporter": "PostgreSQL table connecting",
    "SkimMatrix": "SkimMatrix",
    "TileLayerImporter": "TileLayer import",
    "DemandMatrix": "DemandMatrix",
    "StatisticsDataWriter": "StatisticsDataWriter",
    "CalculationRuner": "CalculationRuner",
    "ChsmeoCamsDataWriter": "ChsmeoCamsDataWriter",
    "LTMProcess": "LTM calculation",
    "DataImport": "Data import",
    "TestWorker": "TestWorker",
    "DueProcess": "DUE calculation",
    "OsrmProcess": "OSRM data preparation",
    "VisumProcess": "Visum test calculation",
    "STA": "STA",
    "GdbImporter": "GDB import",
    "NetImporter": "NET import",
    "DueImporter": "DUE import",
    "CustomImporter": "User layer creating",
    "CsvImporter": "CSV import",
    "DmdImporter": "DMD import",
    "UserImporter": "User data import",
    "JsonImporter": "JSON import",
    "GtfsImporter": "GTFS import",
    "ShpImporter": "SHP import",
    "OsmExport": "OSM export",
    "LtmExport": "LTM export",
    "DueExport": "DUE export",
    "DorfondImporter": "Dorfond import",
    "TracksImporter": "Tracks import",
    "DnlProcess": "DNL calculation"
  }
}
</i18n>
